module.exports = __webpack_public_path__ + "static/media/barbequechicken.317d9396.jpg";